<template>
    <canvas id='available_hours_map_canvas' />
</template>

<script>
import Vue from 'vue';
import Chartkick from 'vue-chartkick';
import * as ChartGeo from 'chartjs-chart-geo'
import Chart from 'chart.js';
import AdminClient from '@/api/AdminClient';
import us from "./states-10m.json"
import Datepicker from 'vuejs-datepicker';

Vue.use(Chartkick.use(Chart));

export default {
    name: 'AvailableHoursByState',
    components: {
        Datepicker
    },
    data() {
        return {
            adminClient: new AdminClient(this.$http),
            total: 0,
            chart:null
        }
    },
    async mounted() {
        const availableByHoursResponse =  await this.adminClient.getAvailableHoursByState();
        const availableByHours = availableByHoursResponse.results;

        this.total = availableByHours.reduce((prev, curr) => prev + curr.hours, 0);

        let canvas = document.getElementById("available_hours_map_canvas")
        if (!canvas) 
            return

        const nation = ChartGeo.topojson.feature(us, us.objects.nation).features[0];
        const states = ChartGeo.topojson.feature(us, us.objects.states).features;

        states.forEach((state) => {
            var stateAvailability = availableByHours.find(availability => availability.state == state.properties.name)
            if(!stateAvailability)
                return
            state.hours = stateAvailability.hours
        })

        this.chart = new Chart(canvas.getContext("2d"), {
            type: 'choropleth',
            data: {
                labels: states.map(d =>  d.properties.name + " Available Hours"),
                datasets: [{
                    label: 'States',
                    outline: nation,
                    data: states.map((d) => ({feature: d, value: d.hours ? d.hours : 0 })),
                }]
            },
            options: {
                legend: { display: false },
                scale: { projection: 'albersUsa' },
                geo: {
                    colorScale: {
                        display: true,
                        position: 'bottom',
                        quantize: 5,
                        legend: { position: 'bottom-right' }, 
                    },
                },
            }
        }); 
    },
    
}
</script>
